import React from "react";

import { useTicketingStore } from "../../../Models/Ticketing/Ticketing.Store";
import { TaskList } from "./TaskList";
import { TicketPanelLayout } from "./TicketPanelLayout";

export function TicketRightPanel() {
  const ticket = useTicketingStore((s) => s.ticket);

  if (!ticket)
    return (
      <TicketPanelLayout headerLeft={<span className="heading-base-alt text-black">Tasks</span>}>
        <div className="body-sm flex flex-1 items-center justify-center text-grey-600">Select a ticket</div>
      </TicketPanelLayout>
    );

  return <TaskList />;
}
